import CustomSlideCheckBoxOption from "./CustomSlideCheckBoxOption";

export default CustomSlideCheckBoxOption;
